<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="32.089"
    height="32.175"
    viewBox="0 0 32.089 32.175"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="Trazado_165"
          data-name="Trazado 165"
          d="M1225.2,3343.83a8.813,8.813,0,0,1-2.979-.553,5.314,5.314,0,0,1-3.044-3.052,8.971,8.971,0,0,1-.554-2.988c-.077-1.7-.092-2.205-.092-6.5s.015-4.805.092-6.5a8.941,8.941,0,0,1,.554-2.986,5.31,5.31,0,0,1,3.044-3.053,8.825,8.825,0,0,1,2.979-.554c1.692-.077,2.2-.1,6.484-.1s4.791.018,6.483.1a8.831,8.831,0,0,1,2.979.554,5.317,5.317,0,0,1,3.044,3.053,8.947,8.947,0,0,1,.553,2.986c.078,1.7.093,2.206.093,6.5s-.015,4.8-.093,6.5a8.977,8.977,0,0,1-.553,2.988,5.321,5.321,0,0,1-3.044,3.052,8.819,8.819,0,0,1-2.979.553c-1.692.078-2.2.1-6.483.1s-4.792-.018-6.484-.1m-.131-29.086a11.729,11.729,0,0,0-3.894.749,8.214,8.214,0,0,0-4.693,4.7,11.854,11.854,0,0,0-.746,3.905c-.077,1.717-.1,2.265-.1,6.635s.021,4.917.1,6.632a11.843,11.843,0,0,0,.746,3.905,8.227,8.227,0,0,0,4.693,4.705,11.734,11.734,0,0,0,3.894.747c1.712.079,2.257.1,6.615.1s4.9-.017,6.614-.1a11.741,11.741,0,0,0,3.894-.747,8.212,8.212,0,0,0,4.693-4.705,11.85,11.85,0,0,0,.745-3.905c.078-1.715.1-2.264.1-6.632s-.019-4.918-.1-6.635a11.86,11.86,0,0,0-.745-3.905,8.2,8.2,0,0,0-4.693-4.7,11.736,11.736,0,0,0-3.894-.749c-1.712-.078-2.258-.1-6.614-.1s-4.9.019-6.615.1"
          :fill="coloricon"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <path
          id="Trazado_167"
          data-name="Trazado 167"
          d="M1226.339,3330.735a5.349,5.349,0,1,1,5.35,5.362,5.357,5.357,0,0,1-5.35-5.362m-2.889,0a8.239,8.239,0,1,0,8.239-8.262,8.25,8.25,0,0,0-8.239,8.262"
          :fill="coloricon"
        />
      </clipPath>
    </defs>
    <g
      id="icono_instagram"
      data-name="icono instagram"
      transform="translate(-1215.643 -2796.694)"
    >
      <g id="Grupo_96" data-name="Grupo 96" transform="translate(0 -517.953)">
        <path
          id="Trazado_164"
          data-name="Trazado 164"
          d="M1225.2,3343.83a8.813,8.813,0,0,1-2.979-.553,5.314,5.314,0,0,1-3.044-3.052,8.971,8.971,0,0,1-.554-2.988c-.077-1.7-.092-2.205-.092-6.5s.015-4.805.092-6.5a8.941,8.941,0,0,1,.554-2.986,5.31,5.31,0,0,1,3.044-3.053,8.825,8.825,0,0,1,2.979-.554c1.692-.077,2.2-.1,6.484-.1s4.791.018,6.483.1a8.831,8.831,0,0,1,2.979.554,5.317,5.317,0,0,1,3.044,3.053,8.947,8.947,0,0,1,.553,2.986c.078,1.7.093,2.206.093,6.5s-.015,4.8-.093,6.5a8.977,8.977,0,0,1-.553,2.988,5.321,5.321,0,0,1-3.044,3.052,8.819,8.819,0,0,1-2.979.553c-1.692.078-2.2.1-6.483.1s-4.792-.018-6.484-.1m-.131-29.086a11.729,11.729,0,0,0-3.894.749,8.214,8.214,0,0,0-4.693,4.7,11.854,11.854,0,0,0-.746,3.905c-.077,1.717-.1,2.265-.1,6.635s.021,4.917.1,6.632a11.843,11.843,0,0,0,.746,3.905,8.227,8.227,0,0,0,4.693,4.705,11.734,11.734,0,0,0,3.894.747c1.712.079,2.257.1,6.615.1s4.9-.017,6.614-.1a11.741,11.741,0,0,0,3.894-.747,8.212,8.212,0,0,0,4.693-4.705,11.85,11.85,0,0,0,.745-3.905c.078-1.715.1-2.264.1-6.632s-.019-4.918-.1-6.635a11.86,11.86,0,0,0-.745-3.905,8.2,8.2,0,0,0-4.693-4.7,11.736,11.736,0,0,0-3.894-.749c-1.712-.078-2.258-.1-6.614-.1s-4.9.019-6.615.1"
          :fill="coloricon"
        />
        <g id="Grupo_95" data-name="Grupo 95" clip-path="url(#clip-path)">
          <rect
            id="Rectángulo_134"
            data-name="Rectángulo 134"
            width="32.19"
            height="32.276"
            transform="translate(1215.542 3314.647) rotate(-0.18)"
            :fill="coloricon"
          />
        </g>
      </g>
      <g id="Grupo_98" data-name="Grupo 98" transform="translate(0 -517.953)">
        <path
          id="Trazado_166"
          data-name="Trazado 166"
          d="M1226.339,3330.735a5.349,5.349,0,1,1,5.35,5.362,5.357,5.357,0,0,1-5.35-5.362m-2.889,0a8.239,8.239,0,1,0,8.239-8.262,8.25,8.25,0,0,0-8.239,8.262"
          :fill="coloricon"
        />
        <g id="Grupo_97" data-name="Grupo 97" clip-path="url(#clip-path-2)">
          <rect
            id="Rectángulo_135"
            data-name="Rectángulo 135"
            width="16.528"
            height="16.575"
            transform="translate(1223.398 3322.473) rotate(-0.181)"
            :fill="coloricon"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    coloricon: {
      default: "#b9b9b9",
    },
  },
};
</script>
